enum GTMEventType {
  BACK = 'boton_atras',
  NEXT = 'boton_continuar',
  SOYDEASISA = 'boton_soydeasisa',
  CALLMEBACK_BTN = 'boton_callmeback',
  CALLMEBACK_FORM = 'form_callmeback',
  EMAIL = 'boton_email',
  FAQS = 'boton_faqs',
  ENCUENTRANOS = 'boton_encuentranos',
  GESTIONES = 'click_gestiones',
  AUTORIZACION = 'boton_autorizacion',
  INCIDENCIA = 'boton_incidencia',
  SUGERENCIA = 'boton_sugerencia',
  RECLAMACION = 'boton_reclamacion',
  BAJA = 'boton_baja',
  BAJA_FALLECIMIENTO = 'boton_baja_fallecimiento',
  CARGA_ARCHIVO = 'carga_archivo',
  OTRABAJA = 'boton_otrabaja',
  IRAHOME = 'click_enlace',
  MENU_FOOTER = 'menu_footer',
  LOGO = 'logo',
  CLICK_PHONE_NUMBER = 'click_telefono',
  SUBMIT_HIRING_STEP = 'submit_paso_contratacion',
  SUBMIT_HIRING = 'submit_contratacion',
  SAVE = 'guardar',
  FINISH_HIRING = 'fin_contratacion',
  SIGN_DOC = 'firmar_documentacion',
  INIT_RATER = 'inicio_tarificador',
  COMPARE = 'comparar',
  RECALCULATE = 'recalcular_seguro',
  VIEW_PRODUCT = 'ver_producto',
  HIRE_ONLINE = 'contrata_online',
  SEND_BUDGET = 'enviar_presupuesto',
  FINISH_RATER = 'fin_tarificador',
  DOWNLOAD = 'descarga_documento'
}

export default GTMEventType
